// Export an array of topics for VA 1st Grade Science
const va1stScienceQuizContent = [
  
  {
    "slug": "motion",
    "title": "Motion",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is motion?",
        "questionImage": "",
        "answers": [
          { "text": "A change in position", "correct": true, "image": "" },
          { "text": "Staying in one place", "correct": false, "image": "" },
          { "text": "Making noise", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If a car moves from one spot to another, what happened?",
        "questionImage": "",
        "answers": [
          { "text": "Motion occurred", "correct": true, "image": "" },
          { "text": "It disappeared", "correct": false, "image": "" },
          { "text": "Nothing changed", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we call something that keeps changing position over time?",
        "questionImage": "",
        "answers": [
          { "text": "It’s in motion", "correct": true, "image": "" },
          { "text": "It’s asleep", "correct": false, "image": "" },
          { "text": "It’s invisible", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which example shows motion?",
        "questionImage": "",
        "answers": [
          { "text": "A rolling ball", "correct": true, "image": "" },
          { "text": "A sitting chair", "correct": false, "image": "" },
          { "text": "A closed door", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What must happen for motion to occur?",
        "questionImage": "",
        "answers": [
          { "text": "Position changes", "correct": true, "image": "" },
          { "text": "Object stays still", "correct": false, "image": "" },
          { "text": "Object makes sound", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "instruments",
    "title": "Instruments",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each instrument to how it makes sound.",
        "options": [
          { "id": "guitar", "text": "Guitar", "image": "", "targetText": "Vibrating strings", "targetImage": "" },
          { "id": "flute", "text": "Flute", "image": "", "targetText": "Vibrating air", "targetImage": "" },
          { "id": "drum", "text": "Drum", "image": "", "targetText": "Vibrating drumhead", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each instrument to its family.",
        "options": [
          { "id": "violin", "text": "Violin", "image": "", "targetText": "Strings", "targetImage": "" },
          { "id": "flute2", "text": "Flute", "image": "", "targetText": "Woodwind", "targetImage": "" },
          { "id": "trumpet", "text": "Trumpet", "image": "", "targetText": "Brass", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match wind instruments to what vibrates.",
        "options": [
          { "id": "fluteEdge", "text": "Flute", "image": "", "targetText": "Air at a sharp edge", "targetImage": "" },
          { "id": "clarinet", "text": "Clarinet", "image": "", "targetText": "A reed", "targetImage": "" },
          { "id": "trumpetBuzz", "text": "Trumpet", "image": "", "targetText": "Buzzing lips", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each percussion instrument to what you strike.",
        "options": [
          { "id": "snare", "text": "Snare drum", "image": "", "targetText": "Drumhead", "targetImage": "" },
          { "id": "cymbals", "text": "Cymbals", "image": "", "targetText": "Metal plates", "targetImage": "" },
          { "id": "triangle", "text": "Triangle", "image": "", "targetText": "Metal bar", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each part to the instrument it helps vibrate.",
        "options": [
          { "id": "stringsPart", "text": "Strings", "image": "", "targetText": "Guitar", "targetImage": "" },
          { "id": "airColumn", "text": "Air column", "image": "", "targetText": "Flute", "targetImage": "" },
          { "id": "drumHeadPart", "text": "Drumhead", "image": "", "targetText": "Drum", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "soundvibration",
    "title": "Sound Vibration",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. When something shakes back and forth, what creates the sound we hear?",
        "questionImage": "",
        "answers": [
          { "text": "Vibration", "correct": true, "image": "" },
          { "text": "Silence", "correct": false, "image": "" },
          { "text": "Stillness", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. On a guitar, which part vibrates to make the sound?",
        "questionImage": "",
        "answers": [
          { "text": "Strings", "correct": true, "image": "" },
          { "text": "Air", "correct": false, "image": "" },
          { "text": "Keys", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What part of your body vibrates to create your voice?",
        "questionImage": "",
        "answers": [
          { "text": "Vocal cords", "correct": true, "image": "" },
          { "text": "Hands", "correct": false, "image": "" },
          { "text": "Feet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps your voice sound soft or loud when you speak or sing?",
        "questionImage": "",
        "answers": [
          { "text": "Vocal cords", "correct": true, "image": "" },
          { "text": "Legs", "correct": false, "image": "" },
          { "text": "Arms", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the main cause of the sounds we hear?",
        "questionImage": "",
        "answers": [
          { "text": "Vibration", "correct": true, "image": "" },
          { "text": "Silence", "correct": false, "image": "" },
          { "text": "Nothing", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "matter",
    "title": "Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each state of matter to its trait.",
        "options": [
          { "id": "solid", "text": "Solid", "image": "", "targetText": "Keeps shape", "targetImage": "" },
          { "id": "liquid", "text": "Liquid", "image": "", "targetText": "Takes container shape", "targetImage": "" },
          { "id": "gas", "text": "Gas", "image": "", "targetText": "Fills container", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match particle motion to the state.",
        "options": [
          { "id": "packed", "text": "Packed tightly", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "slide", "text": "Slide past", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "far", "text": "Far apart", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each example to its state.",
        "options": [
          { "id": "ice", "text": "Ice", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "steam", "text": "Steam", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each container idea.",
        "options": [
          { "id": "balloon", "text": "Air in balloon", "image": "", "targetText": "Gas fills space", "targetImage": "" },
          { "id": "glass", "text": "Juice in glass", "image": "", "targetText": "Liquid takes shape", "targetImage": "" },
          { "id": "block", "text": "Wood block", "image": "", "targetText": "Solid keeps shape", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each change of state to its name.",
        "options": [
          { "id": "sToL", "text": "Solid → Liquid", "image": "", "targetText": "Melting", "targetImage": "" },
          { "id": "lToG", "text": "Liquid → Gas", "image": "", "targetText": "Evaporation", "targetImage": "" },
          { "id": "gToL", "text": "Gas → Liquid", "image": "", "targetText": "Condensation", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "thingsplantsneed",
    "title": "Things Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do plants drink to grow?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Juice", "correct": false, "image": "" },
          { "text": "Milk", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps plants take in gases?",
        "questionImage": "",
        "answers": [
          { "text": "Air", "correct": true, "image": "" },
          { "text": "Sand", "correct": false, "image": "" },
          { "text": "Oil", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the best source of light for plants?",
        "questionImage": "",
        "answers": [
          { "text": "The Sun", "correct": true, "image": "" },
          { "text": "The Moon", "correct": false, "image": "" },
          { "text": "A candle", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What word means plants need room to spread out?",
        "questionImage": "",
        "answers": [
          { "text": "Space", "correct": true, "image": "" },
          { "text": "Rock", "correct": false, "image": "" },
          { "text": "Clouds", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which list shows basic needs for plants?",
        "questionImage": "",
        "answers": [
          { "text": "Water, air, light", "correct": true, "image": "" },
          { "text": "Milk, soda", "correct": false, "image": "" },
          { "text": "Juice, candy", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "plantparts",
    "title": "Plant Parts",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each plant part to its job.",
        "options": [
          { "id": "roots", "text": "Roots", "image": "", "targetText": "Take in water", "targetImage": "" },
          { "id": "stem", "text": "Stem", "image": "", "targetText": "Carry water", "targetImage": "" },
          { "id": "leaves", "text": "Leaves", "image": "", "targetText": "Make food", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match parts to how new plants begin.",
        "options": [
          { "id": "flowers", "text": "Flowers", "image": "", "targetText": "Make seeds", "targetImage": "" },
          { "id": "fruit", "text": "Fruit", "image": "", "targetText": "Protect/hold seeds", "targetImage": "" },
          { "id": "seeds", "text": "Seeds", "image": "", "targetText": "Grow new plant", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match seed words to what they do.",
        "options": [
          { "id": "seed", "text": "Seed", "image": "", "targetText": "Starts a plant", "targetImage": "" },
          { "id": "embryo", "text": "Embryo", "image": "", "targetText": "Baby plant", "targetImage": "" },
          { "id": "seedcoat", "text": "Seed coat", "image": "", "targetText": "Protects embryo", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match root parts to their jobs.",
        "options": [
          { "id": "roots_hold", "text": "Roots", "image": "", "targetText": "Hold plant in place", "targetImage": "" },
          { "id": "root_hairs", "text": "Root hairs", "image": "", "targetText": "Take in water", "targetImage": "" },
          { "id": "storage_root", "text": "Storage root", "image": "", "targetText": "Store food", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match stem words to what they move.",
        "options": [
          { "id": "stem_support", "text": "Stem", "image": "", "targetText": "Supports plant", "targetImage": "" },
          { "id": "xylem", "text": "Xylem", "image": "", "targetText": "Moves water up", "targetImage": "" },
          { "id": "phloem", "text": "Phloem", "image": "", "targetText": "Moves food", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "whatdoplantsneed",
    "title": "What Do Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Plants need something to breathe and to make food. What do they need?",
        "questionImage": "",
        "answers": [
          { "text": "Air", "correct": true, "image": "" },
          { "text": "Metal", "correct": false, "image": "" },
          { "text": "Plastic", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the best kind of light for most plants?",
        "questionImage": "",
        "answers": [
          { "text": "Sunlight", "correct": true, "image": "" },
          { "text": "Moonlight", "correct": false, "image": "" },
          { "text": "Flashlight", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do plants drink through their roots?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Juice", "correct": false, "image": "" },
          { "text": "Milk", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do plants get from soil to help them grow strong?",
        "questionImage": "",
        "answers": [
          { "text": "Nutrients", "correct": true, "image": "" },
          { "text": "Confetti", "correct": false, "image": "" },
          { "text": "Glitter", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Some plants grow in water instead of soil. What are these plants called?",
        "questionImage": "",
        "answers": [
          { "text": "Aquatic", "correct": true, "image": "" },
          { "text": "Metallic", "correct": false, "image": "" },
          { "text": "Robotic", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "plantsandanimalsneedtheirspace",
    "title": "Plants and Animals Need Their Space",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Animals must drink something to live. What is this basic need?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Candy", "correct": false, "image": "" },
          { "text": "Paint", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals need to eat to get energy. What do they need?",
        "questionImage": "",
        "answers": [
          { "text": "Food", "correct": true, "image": "" },
          { "text": "Stickers", "correct": false, "image": "" },
          { "text": "Balloons", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals need a safe place to live. What is this place called?",
        "questionImage": "",
        "answers": [
          { "text": "Shelter", "correct": true, "image": "" },
          { "text": "Noise", "correct": false, "image": "" },
          { "text": "Smoke", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Plants need energy to make food. What provides that energy?",
        "questionImage": "",
        "answers": [
          { "text": "Sunlight", "correct": true, "image": "" },
          { "text": "Gasoline", "correct": false, "image": "" },
          { "text": "Ink", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Living things need the right feel of air or water. What is this called?",
        "questionImage": "",
        "answers": [
          { "text": "Temperature", "correct": true, "image": "" },
          { "text": "Glitter", "correct": false, "image": "" },
          { "text": "Paint", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "animalneeds",
    "title": "Animal Needs",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each need to what it’s for.",
        "options": [
          { "id": "food", "text": "Food", "image": "", "targetText": "Energy to live", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Hydration", "targetImage": "" },
          { "id": "shelter", "text": "Shelter", "image": "", "targetText": "Safe home", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match animal type to its oxygen source.",
        "options": [
          { "id": "terrestrial", "text": "Land animals", "image": "", "targetText": "Air oxygen", "targetImage": "" },
          { "id": "aquatic", "text": "Water animals", "image": "", "targetText": "Water oxygen", "targetImage": "" },
          { "id": "amphib", "text": "Amphibians", "image": "", "targetText": "Both air and water", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each resource to what it gives.",
        "options": [
          { "id": "sunlight", "text": "Sunlight", "image": "", "targetText": "Energy for plants", "targetImage": "" },
          { "id": "food2", "text": "Food", "image": "", "targetText": "Energy for animals", "targetImage": "" },
          { "id": "air", "text": "Air", "image": "", "targetText": "Gases to breathe", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match oxygen places to where it’s found.",
        "options": [
          { "id": "oxygen_air", "text": "Air oxygen", "image": "", "targetText": "Land", "targetImage": "" },
          { "id": "oxygen_water", "text": "Water oxygen", "image": "", "targetText": "Water", "targetImage": "" },
          { "id": "wetlands", "text": "Wetlands mix", "image": "", "targetText": "Both", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each idea to the need it shows.",
        "options": [
          { "id": "space", "text": "Space", "image": "", "targetText": "Room to grow", "targetImage": "" },
          { "id": "habitat", "text": "Habitat", "image": "", "targetText": "Place to live", "targetImage": "" },
          { "id": "group", "text": "Group", "image": "", "targetText": "Help to survive", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "habitats",
    "title": "Habitats",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do we call the place where a plant or animal lives and finds what it needs?",
        "questionImage": "",
        "answers": [
          { "text": "A habitat", "correct": true, "image": "" },
          { "text": "A toy", "correct": false, "image": "" },
          { "text": "A snack", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Who lives together in the same habitat and can make new members of their kind?",
        "questionImage": "",
        "answers": [
          { "text": "Populations", "correct": true, "image": "" },
          { "text": "Robots", "correct": false, "image": "" },
          { "text": "Cars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Habitats give living things what they need. Which is one need?",
        "questionImage": "",
        "answers": [
          { "text": "Food", "correct": true, "image": "" },
          { "text": "Games", "correct": false, "image": "" },
          { "text": "Music", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Habitats also provide another basic need. Which one is it?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Confetti", "correct": false, "image": "" },
          { "text": "Glue", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which of the following is a natural habitat?",
        "questionImage": "",
        "answers": [
          { "text": "A rainforest", "correct": true, "image": "" },
          { "text": "A backpack", "correct": false, "image": "" },
          { "text": "A shoe box", "correct": false, "image": "" }
        ]
      }
    ]
  },

  {
  "slug": "fromthesun",
  "title": "From the Sun",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each water cycle step to what happens.",
      "options": [
        { "id": "evap", "text": "Water heats", "image": "", "targetText": "Evaporation", "targetImage": "" },
        { "id": "cond", "text": "Vapor cools", "image": "", "targetText": "Condensation", "targetImage": "" },
        { "id": "precip", "text": "Water falls", "image": "", "targetText": "Precipitation", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the Sun’s job to the result.",
      "options": [
        { "id": "sun_evap", "text": "Heats water", "image": "", "targetText": "Evaporation", "targetImage": "" },
        { "id": "sun_warm", "text": "Warms air", "image": "", "targetText": "Weather and winds", "targetImage": "" },
        { "id": "sun_light", "text": "Gives light", "image": "", "targetText": "Daytime", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each process to its description.",
      "options": [
        { "id": "cond2", "text": "Condensation", "image": "", "targetText": "Clouds form", "targetImage": "" },
        { "id": "evap2", "text": "Evaporation", "image": "", "targetText": "Water vapor rises", "targetImage": "" },
        { "id": "collect", "text": "Collection", "image": "", "targetText": "Water gathers", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match falling water to its state of matter.",
      "options": [
        { "id": "rain", "text": "Rain", "image": "", "targetText": "Liquid", "targetImage": "" },
        { "id": "snow", "text": "Snow", "image": "", "targetText": "Solid", "targetImage": "" },
        { "id": "hail", "text": "Hail", "image": "", "targetText": "Solid", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match where water collects at the end.",
      "options": [
        { "id": "back_ocean", "text": "Back to oceans", "image": "", "targetText": "Oceans", "targetImage": "" },
        { "id": "into_lakes", "text": "Into lakes", "image": "", "targetText": "Lakes", "targetImage": "" },
        { "id": "into_ground", "text": "Into ground", "image": "", "targetText": "Groundwater", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "thesunbringslight",
  "title": "The Sun Brings Light",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What does the Sun give Earth during the day so we can see?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": true, "image": "" },
        { "text": "Salt", "correct": false, "image": "" },
        { "text": "Glue", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Besides light, what else does the Sun give that warms Earth?",
      "questionImage": "",
      "answers": [
        { "text": "Heat", "correct": true, "image": "" },
        { "text": "Frost", "correct": false, "image": "" },
        { "text": "Fog", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When sunlight hits a shiny surface, what can happen?",
      "questionImage": "",
      "answers": [
        { "text": "It reflects", "correct": true, "image": "" },
        { "text": "It vanishes", "correct": false, "image": "" },
        { "text": "It freezes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When light is taken in by a dark surface, what do we say the light is?",
      "questionImage": "",
      "answers": [
        { "text": "Absorbed", "correct": true, "image": "" },
        { "text": "Ignored", "correct": false, "image": "" },
        { "text": "Lost", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of space object is the Sun?",
      "questionImage": "",
      "answers": [
        { "text": "A star", "correct": true, "image": "" },
        { "text": "A planet", "correct": false, "image": "" },
        { "text": "A comet", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "nightandday",
  "title": "Night and Day",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match causes on Earth to what we see in the sky.",
      "options": [
        { "id": "spin", "text": "Earth spins", "image": "", "targetText": "Day and night", "targetImage": "" },
        { "id": "sunSide", "text": "Sunlit side", "image": "", "targetText": "Daytime", "targetImage": "" },
        { "id": "darkSide", "text": "Shadow side", "image": "", "targetText": "Nighttime", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match time of day to what the Sun looks like.",
      "options": [
        { "id": "morning", "text": "Morning", "image": "", "targetText": "Sun rises in east", "targetImage": "" },
        { "id": "noon", "text": "Noon", "image": "", "targetText": "Sun high in sky", "targetImage": "" },
        { "id": "evening", "text": "Evening", "image": "", "targetText": "Sun sets in west", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each turn to how long it takes.",
      "options": [
        { "id": "oneRot", "text": "One rotation", "image": "", "targetText": "About 24 hours", "targetImage": "" },
        { "id": "halfRot", "text": "Half rotation", "image": "", "targetText": "About 12 hours", "targetImage": "" },
        { "id": "twoRot", "text": "Two rotations", "image": "", "targetText": "About 48 hours", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each sky idea to what seems to happen.",
      "options": [
        { "id": "sunMove", "text": "Sun across sky", "image": "", "targetText": "Looks east→west", "targetImage": "" },
        { "id": "shadows", "text": "Shadows on ground", "image": "", "targetText": "Change during day", "targetImage": "" },
        { "id": "stars", "text": "Stars at night", "image": "", "targetText": "Seem to move", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each space word to what it means.",
      "options": [
        { "id": "rotation", "text": "Rotation", "image": "", "targetText": "Spinning in place", "targetImage": "" },
        { "id": "axis", "text": "Axis", "image": "", "targetText": "Imaginary spin line", "targetImage": "" },
        { "id": "orbit", "text": "Orbit", "image": "", "targetText": "Path around Sun", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "precipitation",
  "title": "Precipitation",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What word describes water that falls from clouds to the ground?",
      "questionImage": "",
      "answers": [
        { "text": "Precipitation", "correct": true, "image": "" },
        { "text": "Fog", "correct": false, "image": "" },
        { "text": "Wind", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which type of precipitation is frozen water?",
      "questionImage": "",
      "answers": [
        { "text": "Snow", "correct": true, "image": "" },
        { "text": "Lightning", "correct": false, "image": "" },
        { "text": "Thunder", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which kind is made of small icy pellets?",
      "questionImage": "",
      "answers": [
        { "text": "Sleet", "correct": true, "image": "" },
        { "text": "Fog", "correct": false, "image": "" },
        { "text": "Mist", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which kind is made of large balls or lumps of ice?",
      "questionImage": "",
      "answers": [
        { "text": "Hail", "correct": true, "image": "" },
        { "text": "Frost", "correct": false, "image": "" },
        { "text": "Glaze", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What are raindrops made of when they fall from clouds?",
      "questionImage": "",
      "answers": [
        { "text": "Liquid droplets", "correct": true, "image": "" },
        { "text": "Flakes", "correct": false, "image": "" },
        { "text": "Pellets", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "seasons",
  "title": "Seasons",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each reason to the season idea.",
      "options": [
        { "id": "tilt", "text": "Earth’s tilt", "image": "", "targetText": "Seasons happen", "targetImage": "" },
        { "id": "sunAngle", "text": "Sunlight angle", "image": "", "targetText": "More/less heating", "targetImage": "" },
        { "id": "revolve", "text": "Earth’s revolution", "image": "", "targetText": "Year-long path", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each season to a clue.",
      "options": [
        { "id": "spring", "text": "Spring", "image": "", "targetText": "New growth", "targetImage": "" },
        { "id": "summer", "text": "Summer", "image": "", "targetText": "Warmest temps", "targetImage": "" },
        { "id": "winter", "text": "Winter", "image": "", "targetText": "Coldest temps", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match season to daylight length.",
      "options": [
        { "id": "sumDay", "text": "Summer", "image": "", "targetText": "Longer days", "targetImage": "" },
        { "id": "winDay", "text": "Winter", "image": "", "targetText": "Shorter days", "targetImage": "" },
        { "id": "sprFallDay", "text": "Spring/Fall", "image": "", "targetText": "In-between", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match season to common change.",
      "options": [
        { "id": "fallLeaves", "text": "Fall", "image": "", "targetText": "Leaves change", "targetImage": "" },
        { "id": "springRain", "text": "Spring", "image": "", "targetText": "More rain", "targetImage": "" },
        { "id": "winterSnow", "text": "Winter", "image": "", "targetText": "Snow/ice", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Put the seasons in order around the year.",
      "options": [
        { "id": "order1", "text": "Spring → Summer", "image": "", "targetText": "Then Fall", "targetImage": "" },
        { "id": "order2", "text": "Summer → Fall", "image": "", "targetText": "Then Winter", "targetImage": "" },
        { "id": "order3", "text": "Fall → Winter", "image": "", "targetText": "Then Spring", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "naturalresources",
  "title": "Natural Resources",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each resource to “Renewable.”",
      "options": [
        { "id": "trees", "text": "Trees", "image": "", "targetText": "Renewable", "targetImage": "" },
        { "id": "fish", "text": "Fish", "image": "", "targetText": "Renewable", "targetImage": "" },
        { "id": "grass", "text": "Grass", "image": "", "targetText": "Renewable", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each fuel to “Nonrenewable.”",
      "options": [
        { "id": "coal", "text": "Coal", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
        { "id": "oil", "text": "Oil", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
        { "id": "gas", "text": "Natural gas", "image": "", "targetText": "Nonrenewable", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each to “Inexhaustible.”",
      "options": [
        { "id": "sun", "text": "Sunlight", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
        { "id": "wind", "text": "Wind", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
        { "id": "water", "text": "Moving water", "image": "", "targetText": "Inexhaustible", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each material to “Recyclable.”",
      "options": [
        { "id": "aluminum", "text": "Aluminum", "image": "", "targetText": "Recyclable", "targetImage": "" },
        { "id": "glass", "text": "Glass", "image": "", "targetText": "Recyclable", "targetImage": "" },
        { "id": "paper", "text": "Paper", "image": "", "targetText": "Recyclable", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each fact to its resource idea.",
      "options": [
        { "id": "natRes", "text": "Made by nature", "image": "", "targetText": "Natural resource", "targetImage": "" },
        { "id": "fuel", "text": "Used for energy", "image": "", "targetText": "Fuel", "targetImage": "" },
        { "id": "renew", "text": "Grows back with time", "image": "", "targetText": "Renewable", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "reducereuserecycle",
  "title": "Reduce, Reuse, Recycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. If we reduce, what do we try to do with the amount we use?",
      "questionImage": "",
      "answers": [
        { "text": "Use less", "correct": true, "image": "" },
        { "text": "Use more", "correct": false, "image": "" },
        { "text": "Throw away", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. If we reuse, what do we do with an item?",
      "questionImage": "",
      "answers": [
        { "text": "Use it again", "correct": true, "image": "" },
        { "text": "Throw it away", "correct": false, "image": "" },
        { "text": "Burn it", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. If we recycle, what happens to old materials?",
      "questionImage": "",
      "answers": [
        { "text": "Made into new things", "correct": true, "image": "" },
        { "text": "Put in trash", "correct": false, "image": "" },
        { "text": "Hidden away", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is a good example of something we can recycle?",
      "questionImage": "",
      "answers": [
        { "text": "Paper", "correct": true, "image": "" },
        { "text": "Food", "correct": false, "image": "" },
        { "text": "Shoes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do people recycle and take care of trash the right way?",
      "questionImage": "",
      "answers": [
        { "text": "To protect Earth", "correct": true, "image": "" },
        { "text": "To make more trash", "correct": false, "image": "" },
        { "text": "To pollute", "correct": false, "image": "" }
      ]
    }
  ]
},
  
];

export default va1stScienceQuizContent;
